var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalcManFoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "27px",
    viewBox: "0 0 22 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CalcManFoot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalcManFoot",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.40404829,7 L12.0507272,8.32228032 C17.6523641,7.54033043 20.4680017,6.51880007 22.2858169,8.50680826 L22.7995472,9.07058699 C23.4713485,10.4550563 22.40437,12.674489 20.3494486,13.500277 L5.11536727,19.7772855 C2.14165879,20.5041828 -0.98024114,19.4449313 -1,16.699441 C-1,16.699441 -0.98024114,9.01961243 0.373240791,8.71580399 C3.09996351,8.10410917 2.02310563,7.58314907 4.40404829,7",
    fill: "#27427A",
    transform: "translate(11.000000, 13.500000) rotate(70.000000) translate(-11.000000, -13.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcManFoot);
export default __webpack_public_path__ + "static/media/CalcManFoot.b451d29a30e459f8d15d67e5c4ad6c36.svg";
export { ForwardRef as ReactComponent };